import {combineReducers} from '@reduxjs/toolkit';

import {vehicleSeriesDefinitionReducer} from '../vehicleSeriesDefinition/reducer';

export const vehicleSettingsReducer = combineReducers({
  vehicleSeriesDefinition: vehicleSeriesDefinitionReducer,
});
